(function(){
  'use strict';
  angular.module("irricrops")
    .directive('irrifooter', [ '$timeout', function($timeout) {
      return {templateUrl: 'shared/footer/footer.tmpl.html',};
    }]);
})();
